import React from 'react';
import { connect } from 'react-redux'
import actions from '../../redux/actions'
import CameraComponents from '../../components/Camera/bookBank'
import { FACING_MODES, IMAGE_TYPES } from 'jslib-html5-camera-photo';

class CameraBookBank extends React.Component {
    constructor (props, context) {
        super(props, context);
        this.onTakePhoto = this.onTakePhoto.bind(this);
    }

    onTakePhoto (dataUri) {
      this.props.setBookBankPicture(dataUri);
      this.props.history.push('/preview-book-bank');
    }

    render () {
        console.log(window.innerWidth, window.innerHeight)
        return (
            <CameraComponents
              onClick = {() => this.props.history.push('/how-to-book-bank')}
              onTakePhoto = { (dataUri) => { this.onTakePhoto(dataUri); } }
              idealFacingMode = {FACING_MODES.ENVIRONMENT}
              // idealResolution = {{width: 0 , height: 1400}}
              resolution = {{width: window.innerWidth, height: window.innerHeight}}
              imageType = {IMAGE_TYPES.JPG}
              imageCompression = {0.97}
              isMaxResolution = {false}
              isImageMirror = {false}
              isDisplayStartCameraError = {true}
              isFullscreen = {true}
              sizeFactor = {1}
            />
        );
    }
}

const mapDispatchToProps = {
  setBookBankPicture: actions.setBookBankPicture,
}

const CameraBookBankCardWithConnect = connect(null, mapDispatchToProps)(CameraBookBank)

export default CameraBookBankCardWithConnect
